import {ARRANGEMENT_TRACK_PATTERN} from '../constants.js';
import {deletePatternsSelection} from './deletePatternsSelection.js';
import Resolution from 'engine/Resolution.js';
import {setSelectedArrangementEvents} from 'actions/index.js';
import {setArrangementMouseX} from 'actions/index.js';
import {setArrangementCursorStep} from 'actions/index.js';
import {getBarWidth} from 'components/arrangement/getBarWidth.js';
import {INFO_COLUMN_WIDTH} from 'components/arrangement/constants.js';

class DuplicatePianoRollPattern {
    constructor(track, pattern) {
        this.pattern = pattern;
        this.track = track;
    }

    async execute() {
        deletePatternsSelection(
            this.track,
            this.pattern.endStep,
            this.pattern.endStep + this.pattern.length());
        let newPattern = await this.pattern.getCopy();
        newPattern.track = this.track;
        newPattern.startStep = this.pattern.startStep + this.pattern.length();
        this.track.patterns.push(newPattern);
        this.track.updateSteps(true);
        let selectedEvents = {};
        selectedEvents[ARRANGEMENT_TRACK_PATTERN] = newPattern;
        this.track.sequencerEngine.store.dispatch(
            setSelectedArrangementEvents(selectedEvents));
        let end = newPattern.startStep;
        this.track.sequencerEngine.store.dispatch(
            setArrangementCursorStep(end));
    }

    get xScale() {
        return this.track.sequencerEngine.state.arrangement.xScale;
    }
}

export default DuplicatePianoRollPattern;
